"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = void 0;
exports.build_data = { "build_version": "3.3.12.15", "build_date": "2025-08-20T14:03:30.171Z", "build_branch": "development", "build_commit": "c12398b8cd9e363ce13aac829a0a5d82b42730c3" };
//# sourceMappingURL=build_data.js.map